import graphqlClient from "../../api/axios_interceptor";
import { getDashboardSummaryQuery } from "../../api/graphql/queries/dashboard_summary";
import { FETCH_DASHBOARD_SUMMARY } from "../actions/actionTypes";
import { updateActionErrors } from "./updateErrors";

const dashboardSummaryMiddleware  = storeAPI => next =>async action => {

    switch(action.type){
        case FETCH_DASHBOARD_SUMMARY:
            try {
                await graphqlClient({
                    data: {
                      query: getDashboardSummaryQuery(action.payload)
                    }
                  }).then((queryResult) => {
                    if (queryResult.data.errors) {
                        action = updateActionErrors(action, queryResult.data.errors);
                    } else {
                        let summary = queryResult.data.data.dashboardSummary;
                      action = ({
                        ...action,
                        payload: {
                            ...action.payload,
                            summary
                        }
                    });
                    }
                  });


            } catch (error) {
                console.error(error);
                action = updateActionErrors(action, error)
            }
            break;
    }
    return next(action);
};

export {
    dashboardSummaryMiddleware
}